import _ from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  fetchError: null,
  data: {},
  submitting: false,
  submitted: false,
  submitError: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.VERIFICATION_CLOSE_FETCHING:
      return {
        ...state,
        fetching: payload,
        fetched: payload ? false : state.fetched,
      };

    case types.VERIFICATION_CLOSE_FETCH:
      const { data } = payload;

      return {
        ...state,
        data,
      };

    case types.VERIFICATION_CLOSE_FETCH_ERROR:
      const hardCodedError = {
        Title: 'Error',
        Message:
          'An error occurred while fetching the Verification Close status. Please try again',
      };

      if (_.has(payload, 'response.data')) {
        if (payload.response.data.Errors === undefined) {
          return {
            ...state,
            fetchError: hardCodedError,
          };
        }

        const fetchError = payload.response.data.Errors[0];
        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: hardCodedError,
      };

    case types.VERIFICATION_CLOSE_SUBMITTING:
      return {
        ...state,
        submitting: payload,
        submitted: payload ? false : state.submitted,
      };

    case types.VERIFICATION_CLOSE_SUBMIT:
      return {
        ...state,
        submitted: true,
      };

    case types.VERIFICATION_CLOSE_SUBMIT_ERROR:
      const hardCodedSubmitError = {
        Title: 'Error',
        Message:
          'An error occurred while submitting Close Verification. Please try again',
      };
      if (_.has(payload, 'response.data')) {
        if (payload.response.data.Errors === undefined) {
          return {
            ...state,
            fetchError: hardCodedSubmitError,
          };
        }

        const fetchError = payload.response.data.Errors[0];
        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: hardCodedSubmitError,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/verificationclose/state/verificationclose/reducer.js